/* eslint-disable consistent-return */
/* eslint-disable spaced-comment */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Modal,
  Spin,
  Button,
  TreeSelect,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { onError } from 'utils/handlers';
import Select from 'components/Select';
import Table from 'components/Table';
import { checkToken } from 'api/utils';
import {
  getDatoDePagoDelHonorarioAsimilado,
  getDatosDePagoDeHonorariosAsimilados,
  patchDatoDePagoDelHonorarioAsimilado,
  postDatoDePagoDelHonorarioAsimilado,
} from 'api/estructuraOrganizacional/datosDePagoDeHonorariosAsimilados';
import { getEstadosGlobales } from 'api/catalogos';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS,
  TIPO_DE_DEPOSITO_CLABE,
  TIPO_DE_DEPOSITO_DEBITO,
} from 'utils/constants';
import moment from 'moment';
import { getCuentasContables } from 'api/catalogos/CuantasContables';
import makeTreeCuentasContable from 'utils/makeTreeFromCuentasContables';

export const empleadoFormaPagoPermission = {
  permissionModel: 'formadepagoaempleadobeneficiario',
  catalogsModels: [],
  tabsModels: [],
};

const HonorarioAsimiladoFormaPago = ({
  empleado_id,
  rules,
  metodosDePagos,
  bancos,
  tiposDeDepositos,
  permission,
  isBlocked,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [validateNoCuenta, setValidateNoCuenta] = useState('');
  const [validateClabe, setValidateClabe] = useState('');
  const [disableEdit, setDisableEdit] = useState(false);

  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [formasDePagosEmpleados, setFormasDePagosEmpleados] = useState([]);
  const [cuentasContablesList, setCuentasContablesList] = useState([]);

  const [deshabilitarTipoDepostio, setDeshabilitarTipoDepostio] = useState(false);
  const [deshabilitarCuentaContable, setDeshabilitarCuentaContable] = useState(false);
  const [deshabilitarBanco, setDeshabilitarBanco] = useState(false);
  const [deshabilitarNumeroTarjeta, setDeshabilitarNumeroTarjeta] = useState(false);
  const [deshabilitarClabe, setDeshabilitarClabe] = useState(false);
  const [cuentasContables, setCuentasContables] = useState([]);

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const ordenarPorEstatus = (a, b) => a.estados_globales - b.estados_globales;
  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        const hasCuentasChildren = children.some((e) => e.conac);
        const selectable = clone.tipo !== 7 && !hasCuentasChildren;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            //disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          //disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  useEffect(() => {
    let mounted = true;
    if (!empleado_id) {
      setFormasDePagosEmpleados([]);
      return undefined;
    }
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _formasDePagosEmpleados,
        _cuentasContables,
        _estadosGlobales,
      ] = await Promise.all([
        getDatosDePagoDeHonorariosAsimilados({ honorario_asimilado: empleado_id }),
        getCuentasContables(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        _formasDePagosEmpleados.reverse(ordenarPorEstatus);
        _formasDePagosEmpleados.sort(ordenarPorEstatus);

        setFormasDePagosEmpleados(_formasDePagosEmpleados);
        setCuentasContablesList(_cuentasContables.map((item) => ({
          id: item.id,
          descripcion: `${item.clave_visible || item.clave} - ${item.nombre}`,
        })));
        const normalizedCuentas = normalizeCuentasContables(makeTreeCuentasContable(_cuentasContables));
        setCuentasContables(normalizedCuentas);
        setEstadosGlobales(_estadosGlobales);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [empleado_id]);

  const fetchDatosDePagosEmpleados = async () => {
    setLoading(true);
    const _datosDePagosEmpleados = await getDatosDePagoDeHonorariosAsimilados({ honorario_asimilado: empleado_id });
    _datosDePagosEmpleados.reverse(ordenarPorEstatus);
    setFormasDePagosEmpleados(_datosDePagosEmpleados);
    setLoading(false);
  };

  const columns = [
    {
      key: 'metodo_de_pago',
      dataIndex: 'metodo_de_pago',
      titleText: 'Formas de Pago',
      width: 350,
      render: (metodo_de_pago_id) => metodosDePagos.find((metodoDePago) => metodoDePago.id === metodo_de_pago_id)?.concepto,
    },
    {
      key: 'tipos_de_depositos',
      dataIndex: 'tipos_de_depositos',
      titleText: 'Tipo de Depósito',
      width: 200,
      render: (tipo_deposito_id) => tiposDeDepositos.find((tipoDeposito) => tipoDeposito.id === tipo_deposito_id)?.concepto,
    },
    {
      key: 'banco',
      dataIndex: 'banco',
      titleText: 'Banco',
      width: 200,
      render: (banco_id) => bancos.find((banco) => banco.id === banco_id)?.nombre,
    },
    {
      key: 'numero_tarjeta',
      dataIndex: 'numero_tarjeta',
      titleText: 'No. de Cuenta',
      width: 200,
      render: (numero_tarjeta) => {
        const numbers = numero_tarjeta?.match(/.{1,4}/g);
        return numbers ? `${numbers[0] || ''} ${numbers[1] || ''} ${numbers[2] || ''} ${numbers[3] || ''}` : '';
      },
    },
    {
      key: 'clabe',
      dataIndex: 'clabe',
      titleText: 'CLABE',
      width: 250,
    },
    {
      key: 'requiere_cuenta_contable_especifica',
      dataIndex: 'requiere_cuenta_contable_especifica',
      titleText: 'Requiere Cuenta Contable Especifica',
      width: 300,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      key: 'cuenta_contable',
      dataIndex: 'cuenta_contable',
      titleText: 'Cuenta Contable',
      width: 250,
      render: (cuenta_contable_id) => cuentasContablesList.find((cuentaContable) => cuentaContable.id === cuenta_contable_id)?.descripcion,
    },
    {
      key: 'fecha_de_baja',
      dataIndex: 'fecha_de_baja',
      titleText: 'Fecha de Baja',
      width: 250,
      render: (val) => {
        if (val !== null) {
          const formated = moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY');
          return formated;
        }
      },
    },
    {
      key: 'estados_globales',
      dataIndex: 'estados_globales',
      titleText: 'Estatus',
      width: 150,
      render: (estado_global_id) => estadosGlobales.find((estadoGlobal) => estadoGlobal.id === estado_global_id)?.descripcion,
    },
  ];

  const deshabilitarCampos = ({
    tipoDeposito = false,
    banco = false,
    numeroTarjeta = false,
    clabe = false,
    _cuentaContable = false,
  }) => {
    setDeshabilitarTipoDepostio(tipoDeposito);
    setDeshabilitarBanco(banco);
    setDeshabilitarNumeroTarjeta(numeroTarjeta);
    setDeshabilitarClabe(clabe);
    setDeshabilitarCuentaContable(_cuentaContable);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || formasDePagosEmpleados.find((item) => item.id === key);
    const _formaDePagoEmpleado = await getDatoDePagoDelHonorarioAsimilado(match.id);
    setTimeout(() => {
      if (_formaDePagoEmpleado) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(_formaDePagoEmpleado);
          setOpenModal(true);
        });
      }
    });

    //? Validar forma de pago al editar
    if (_formaDePagoEmpleado.metodo_de_pago !== METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS) {
      deshabilitarCampos({
        tipoDeposito: true,
        banco: true,
        numeroTarjeta: true,
        clabe: true,
        _cuentaContable: true,
      });
    } else {
      deshabilitarCampos({});
    }

    //? Validar tipo de deposito al editar
    if (_formaDePagoEmpleado.tipos_de_depositos === TIPO_DE_DEPOSITO_DEBITO) {
      setDeshabilitarClabe(true);
    } else {
      setDeshabilitarNumeroTarjeta(true);
    }

    setLoading(false);
  };

  const onCancel = () => {
    setOpenModal(false);
    setSelectedRowKeys([]);
    setValidateNoCuenta('');
    setValidateClabe('');
    form.resetFields();
  };

  const inactivarFormasDePagosDelEmpleado = async (formasDePagosActivos) => {
    await Promise.all(formasDePagosActivos.map(async (formaDePago) => {
      formaDePago.estados_globales = ESTATUS_INACTIVO;
      formaDePago.fecha_de_baja = moment().format('YYYY-MM-DD');
      await patchDatoDePagoDelHonorarioAsimilado(formaDePago.id, formaDePago);
    }));
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = {
        ...form.getFieldsValue(),
        honorario_asimilado: empleado_id,
      };

      let saved = false;

      // Modificamos todos los registro anteriores activos para inactivarlo (si es modificación):
      const datosDePagosDeEmpleadosActivos = await getDatosDePagoDeHonorariosAsimilados({ honorario_asimilado: empleado_id, estados_globales: ESTATUS_ACTIVO });

      // Creamos un nuevo registro en base de datos al editarlo y ponemos estatus activo en caso de ser modificación:
      values.estados_globales = ESTATUS_ACTIVO;
      saved = await postDatoDePagoDelHonorarioAsimilado(values);

      if (saved) {
        await inactivarFormasDePagosDelEmpleado(datosDePagosDeEmpleadosActivos);
        if (_continue) {
          await fetchDatosDePagosEmpleados();
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchDatosDePagosEmpleados();
        }
      }
      setLoading(false);
    } catch (error) {
      onError(
        error,
        setLoading,
      );
    }
  };

  const onClickAdd = () => {
    deshabilitarCampos({
      tipoDeposito: true,
      banco: true,
      numeroTarjeta: true,
      clabe: true,
      _cuentaContable: true,
    });
    setSelectedRowKeys([]);
    form.resetFields();
    setOpenModal(true);
  };

  const resetearCamposForm = ({
    tipoDeposito = false,
    banco = false,
    numeroTarjeta = false,
    clabe = false,
    _cuentaContable = false,
  }) => {
    if (tipoDeposito) form.setFieldValue('tipos_de_depositos', null);
    if (banco) form.setFieldValue('banco', null);
    if (numeroTarjeta) form.setFieldValue('numero_tarjeta', null);
    if (clabe) form.setFieldValue('clabe', null);
    if (_cuentaContable) form.setFieldValue('requiere_cuenta_contable_especifica', false);
  };

  const onChangeFormaDePago = async (metodoPago) => {
    if (metodoPago === METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS) {
      resetearCamposForm({});
      deshabilitarCampos({ numeroTarjeta: true, clabe: true });
      return;
    }

    resetearCamposForm({
      tipoDeposito: true,
      banco: true,
      numeroTarjeta: true,
      clabe: true,
      _cuentaContable: true,
    });
    deshabilitarCampos({
      tipoDeposito: true,
      banco: true,
      numeroTarjeta: true,
      clabe: true,
      _cuentaContable: true,
    });
    setValidateNoCuenta('');
    setValidateClabe('');
    await form.validateFields();
  };

  const onChangeTipoDeposito = async (tipoDeposito) => {
    if (tipoDeposito === TIPO_DE_DEPOSITO_DEBITO) {
      resetearCamposForm({ clabe: true });
      deshabilitarCampos({ clabe: true });
      setValidateClabe('');
      form.validateFields(['clabe']);
    }

    if (tipoDeposito === TIPO_DE_DEPOSITO_CLABE) {
      resetearCamposForm({ numeroTarjeta: true });
      deshabilitarCampos({ numeroTarjeta: true });
      setValidateNoCuenta('');
      form.validateFields(['numero_tarjeta']);
    }
  };

  const handleOnRowClick = (_selection) => {
    if (_selection?.estados_globales !== ESTATUS_ACTIVO) {
      setDisableEdit(true);
    } else {
      setDisableEdit(false);
    }
    setSelectedRowKeys([_selection.id]);
    form.setFieldsValue(_selection);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const esNumero = (value) => {
    const numeroEnteroBooleano = (/^\d+$/.test(value));

    if (!numeroEnteroBooleano) {
      return 'error';
    }

    return 'success';
  };

  const onChangeNumeroTarjeta = ({ target: { value } }) => {
    // Si se deja vacio el campo, se quita el estatus de error.
    if (value?.length < 1 || !value) {
      setValidateNoCuenta('');
      return;
    }

    // Si no esta dentro del rango no es una tarjeta valida.
    if (value?.length >= 8 && value?.length <= 16) {
      setValidateNoCuenta(esNumero(value));
    } else {
      setValidateNoCuenta('error');
    }
  };

  const onChangeClabe = ({ target: { value } }) => {
    // Si se deja vacio el campo, se quita el estatus de error.
    if (value?.length < 1 || !value) {
      setValidateClabe('');
      return;
    }

    // Si no esta dentro del rango no es una tarjeta valida.
    if (value?.length === 18) {
      setValidateClabe(esNumero(value));
    } else {
      setValidateClabe('error');
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={formasDePagosEmpleados}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
          }}
          permission={permission}
          allowDelete={false}
          allowExportParam={false}
          allowDoubleClick={false}
          disableEdit={disableEdit}
          //disableAdd={isBlocked}
          disableDelete={isBlocked}
        />
        <Modal
          open={openModal}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width={500}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys?.length ? 'Editar' : 'Agregar'} Forma de Pago`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            form={form}
            name="general"
            layout="vertical"
            onFinish={onFinish}
            scrollToFirstError
            initialValues={{ requiere_cuenta_contable_especifica: false }}
          >
            <Col span={24}>
              <Form.Item
                name="metodo_de_pago"
                label="Forma de Pago"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  keyProp="id"
                  labelProp="concepto"
                  dataSource={metodosDePagos}
                  onChange={onChangeFormaDePago}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="tipos_de_depositos"
                label="Tipo de Depósito"
                hasFeedback
                rules={!deshabilitarTipoDepostio ? rules.required : null}
              >
                <Select
                  keyProp="id"
                  labelProp="concepto"
                  dataSource={tiposDeDepositos}
                  disabled={deshabilitarTipoDepostio || isBlocked}
                  onChange={onChangeTipoDeposito}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="banco"
                label="Banco"
                hasFeedback
                rules={!deshabilitarBanco ? rules.required : null}
              >
                <Select
                  keyProp="id"
                  labelProp="nombre"
                  dataSource={bancos}
                  disabled={deshabilitarBanco || isBlocked}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="numero_tarjeta"
                label="No. de Cuenta"
                hasFeedback
                rules={[rules.numero_tarjeta[0], !deshabilitarNumeroTarjeta ? requiredRule : undefined]}
                validateStatus={validateNoCuenta}
              >
                <Input
                  maxLength={16}
                  disabled={deshabilitarNumeroTarjeta || isBlocked}
                  onChange={onChangeNumeroTarjeta}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="clabe"
                label="CLABE"
                hasFeedback
                rules={[rules.CLABE[0], !deshabilitarClabe ? requiredRule : undefined]}
                validateStatus={validateClabe}
              >
                <Input
                  maxLength={18}
                  disabled={deshabilitarClabe || isBlocked}
                  onChange={onChangeClabe}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="requiere_cuenta_contable_especifica"
                label="Requiere Cuenta Contable Especifica"
                rules={[!deshabilitarCuentaContable ? requiredRule : undefined]}
                hasFeedback
              >
                <Select
                  trueFalse
                  disabled={deshabilitarCuentaContable}
                />
              </Form.Item>
            </Col>
            <Form.Item noStyle shouldUpdate={(prev, curr) => prev.requiere_cuenta_contable_especifica !== curr.requiere_cuenta_contable_especifica}>
              {({ getFieldValue }) => getFieldValue('requiere_cuenta_contable_especifica') === true && (
                <Col span={24}>
                  <Form.Item
                    name="cuenta_contable"
                    label="Cuenta Contable"
                    rules={rules.required}
                  >
                    <TreeSelect
                      keyProp="clave"
                      labelProp="nombre"
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={cuentasContables}
                    />
                  </Form.Item>
                </Col>
              )}
            </Form.Item>
            <Col span={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                hasFeedback
                required={rules.required}
                initialValue={1}
              >
                <Select
                  keyProp="id"
                  labelProp="descripcion"
                  dataSource={estadosGlobales}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Col>
          </Form>
        </Modal>
      </Spin>
    </Row>
  );
};

export default HonorarioAsimiladoFormaPago;
